<form [formGroup]="creditCardForm" class="w-full">
  <h3>Card information</h3>

  <app-shared-input
    [control]="creditCardForm.controls['firstName']"
    label="First Name"
    dataAutoId="first-name-input">
  </app-shared-input>

  <app-shared-input
    [control]="creditCardForm.controls['lastName']"
    label="Last Name"
    dataAutoId="last-name-input">
  </app-shared-input>

  <app-shared-input
    [control]="creditCardForm.controls['cardNumber']"
    label="Card Number"
    [maxLength]="maxLengthCardNumber"
    dataAutoId="card-number-input"
    [cardBrandImage]="cardTypeSrc">
    <small extra-error *ngIf="!creditCardForm.controls['cardNumber'].errors?.['required'] && cardValidityCheckDetails && !cardValidityCheckDetails.valid">
      Card Number is not valid.
    </small>
  </app-shared-input>

  <div class="p-fieldset field">
    <label for="expiration-date-input" class="font-medium">Expiration Date (MM/YY)</label>
    <div *ngIf="creditCardForm.controls['expirationDateInput'].errors?.['required']" class="required">
      <span class="bg-slate-100">Required</span>
    </div>
    <div *ngIf="creditCardForm.controls['expirationDateInput'].touched && creditCardForm.controls['expirationDateInput'].errors?.['required']" class="required text-orange-900">
      <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
    </div>
    <input
      id="expiration-date-input"
      pInputText
      formControlName="expirationDateInput"
      class="flex w-full"
      maxlength="5"
      (input)="formatExpirationDate($event)"
      placeholder="MM/YY"
      data-auto-id="expiration-date-input"
    />
    <div *ngIf="creditCardForm.controls['expirationDateInput'].touched" class="mt-1 text-rose-600">
      <small *ngIf="creditCardForm.controls['expirationDateInput'].errors?.['required']">
        Expiration Date is required.
      </small>
      <small *ngIf="creditCardForm.controls['expirationDateInput'].errors?.['invalidDate']">
        Expiration Date must be in MM/YY format (01-12/YY).
      </small>
      <small *ngIf="creditCardForm.controls['expirationDateInput'].errors?.['pastDate']">
        Expiration Date cannot be in the past.
      </small>
    </div>
  </div>

  <app-shared-input
    [control]="creditCardForm.controls['cvv']"
    label="CVV"
    [maxLength]="maxLengthCvv"
    dataAutoId="cvv-input">
    <small extra-error *ngIf="!creditCardForm.controls['cvv'].errors && cardValidityCheckDetails && !cardValidityCheckDetails.cvvValid">
      CVV is not valid.
    </small>
  </app-shared-input>

</form>
